import sketch from './app/sketch';
import './scss/styles.scss';

// Initialize sketch
new p5(sketch);